import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/69_card_back_heart_glasses/69_card_back_heart_glasses"
 * Contains 1 texture(s)
 */
export class CardsBacks69CardBackHeartGlassesAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/69_card_back_heart_glasses/69_card_back_heart_glasses';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '69_heart_glasses.png'
    ] as const;
}
